import { useQuery } from '@tanstack/react-query'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { ApiError } from '../lib/api'
import { adminApi, type AdminMe } from '../lib/adminApi'

/**
 * 관리자 라우트 가드.
 *
 * **이건 보안 장치가 아니다.** 화면을 감춰도 API를 직접 부르면 그만이므로 실제 차단은
 * 서버의 `requireAdmin`이 한다. 여기서 하는 일은 로그인 안 된 사람을 로그인 화면으로
 * 보내는 것뿐이다.
 */
export function useAdminMe() {
  return useQuery<AdminMe>({
    queryKey: ['admin-me'],
    queryFn: () => adminApi.me(),
    // 401은 "아직 로그인 안 함"이라는 정상 상태다 — 재시도하면 로그인 화면 전환만 늦어진다.
    retry: (count, error) => !(error instanceof ApiError && error.status === 401) && count < 2,
    staleTime: 60_000,
  })
}

export function RequireAdmin(props: { children: ReactNode }) {
  const me = useAdminMe()
  const location = useLocation()

  if (me.isPending) return <p className="muted small">확인 중…</p>

  if (me.error instanceof ApiError && me.error.status === 401) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
  }
  if (me.error) {
    return (
      <div className="notice error">
        <b>관리자 정보를 확인하지 못했습니다.</b>{' '}
        {me.error instanceof ApiError ? (me.error.detail[0] ?? me.error.code) : ''}
      </div>
    )
  }

  return <>{props.children}</>
}
